/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductRegisterSkuProductItem
 */
export interface ProductRegisterSkuProductItem {
    /**
     * 商品URL
     * @type {string}
     * @memberof ProductRegisterSkuProductItem
     */
    productUrl?: string;
    /**
     * 商品图片URL
     * @type {string}
     * @memberof ProductRegisterSkuProductItem
     */
    imageUrl?: string;
    /**
     * 单价
     * @type {number}
     * @memberof ProductRegisterSkuProductItem
     */
    unitPrice: number;
    /**
     * 颜色
     * @type {string}
     * @memberof ProductRegisterSkuProductItem
     */
    color?: string;
    /**
     * 尺寸
     * @type {string}
     * @memberof ProductRegisterSkuProductItem
     */
    size?: string;
    /**
     * 构成数量
     * @type {number}
     * @memberof ProductRegisterSkuProductItem
     */
    productNumber: number;
    /**
     * 通关类目ID
     * @type {number}
     * @memberof ProductRegisterSkuProductItem
     */
    ctmsItemId?: number;
    /**
     * 海关商品英文名
     * @type {string}
     * @memberof ProductRegisterSkuProductItem
     */
    coProNmEn?: string;
    /**
     * 海关编码(HS Code)
     * @type {string}
     * @memberof ProductRegisterSkuProductItem
     */
    coHsCode?: string;
}

/**
 * Check if a given object implements the ProductRegisterSkuProductItem interface.
 */
export function instanceOfProductRegisterSkuProductItem(value: object): value is ProductRegisterSkuProductItem {
    if (!('unitPrice' in value) || value['unitPrice'] === undefined) return false;
    if (!('productNumber' in value) || value['productNumber'] === undefined) return false;
    return true;
}

export function ProductRegisterSkuProductItemFromJSON(json: any): ProductRegisterSkuProductItem {
    return ProductRegisterSkuProductItemFromJSONTyped(json, false);
}

export function ProductRegisterSkuProductItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductRegisterSkuProductItem {
    if (json == null) {
        return json;
    }
    return {
        
        'productUrl': json['productUrl'] == null ? undefined : json['productUrl'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'unitPrice': json['unitPrice'],
        'color': json['color'] == null ? undefined : json['color'],
        'size': json['size'] == null ? undefined : json['size'],
        'productNumber': json['productNumber'],
        'ctmsItemId': json['ctmsItemId'] == null ? undefined : json['ctmsItemId'],
        'coProNmEn': json['coProNmEn'] == null ? undefined : json['coProNmEn'],
        'coHsCode': json['coHsCode'] == null ? undefined : json['coHsCode'],
    };
}

export function ProductRegisterSkuProductItemToJSON(json: any): ProductRegisterSkuProductItem {
    return ProductRegisterSkuProductItemToJSONTyped(json, false);
}

export function ProductRegisterSkuProductItemToJSONTyped(value?: ProductRegisterSkuProductItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'productUrl': value['productUrl'],
        'imageUrl': value['imageUrl'],
        'unitPrice': value['unitPrice'],
        'color': value['color'],
        'size': value['size'],
        'productNumber': value['productNumber'],
        'ctmsItemId': value['ctmsItemId'],
        'coProNmEn': value['coProNmEn'],
        'coHsCode': value['coHsCode'],
    };
}

